import { CdkDragDrop } from '@angular/cdk/drag-drop';
import { Component, Injectable, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { State } from '@app/state';
import { BaseComponent } from '@components/base.component';
import { RoleService } from '@services/role.service';
@Component({
  selector: 'app-role-sort',
  templateUrl: './role-sort.component.html',
  styleUrls: [],
})

@Injectable()
export class RoleSortComponent extends BaseComponent implements OnInit {
  public dataLoaded = false;
  public datasource: [];
  constructor(
    public activatedRoute: ActivatedRoute,
    public roleService: RoleService,
    public state: State,
  ) {
    super();
    this.setObjects({
      route: activatedRoute,
      state: state,
      modelService: roleService,
    });
  }

  ngOnInit(): void {
    this.modelServiceGetAll()
      .then(() => {
        this.datasource = this.dataSourceRows.sort(grp => grp.display_order);
        this.dataLoaded = true;
      });
  }

  drop($event: CdkDragDrop<string[]>) {
    const replacedElement = this.datasource[$event.currentIndex];
    const replacingElement = this.datasource[$event.previousIndex];

    // Swap the element
    const temp = this.datasource[$event.currentIndex];
    this.datasource[$event.currentIndex] = this.datasource[$event.previousIndex];
    this.datasource[$event.previousIndex] = temp;

    // TODO : These two requests should be handle in one request i-e updateDisplayOrder() at API side.
    // update the new/replacing element
    const id = $event.item.element.nativeElement.id;
    if (id) {
      const ind = $event.currentIndex + 1;
      this.roleService
        .patchById(id, { display_order: ind }, null, 'id')
        .subscribe(result => this.ReplacedDisplayOrder(replacingElement, replacedElement));
    }
  }

  private ReplacedDisplayOrder(replacingElement, replacedElement) {
    // update the replaced element
    const id = replacedElement.id;
    if (id) {
      const ind = replacingElement.display_order;
      this.roleService.patchById(id, { display_order: ind }, null, 'id').subscribe();
    }
  }

  public closeSlideout() {
    this.state.message({ ['RoleIndexUpdate']: true });
    this.state.message({ slideoutHide: true });
  }
}
